import { RefObject, useCallback, useEffect } from 'react';
import { useWindowResizeEffect } from '@/common/customHooks';
import { Farm } from '@/rtk/farmsApi';
import { CollapsedPanelStates } from '@/reducers/types/collapsedPanelStateTypes';
import { HubDevice } from '@/rtk/hubDevicesApi';
import { SettingsActivity } from '@/rtk/settingsActivityTypes';

const DYNAMIC_TABLE_HEIGHT_VAR = '--dynamic-table-height';

const PAGE_BOTTOM_PADDING_PX = 8;

const useTableHeightResize = (
  data: Farm[] | HubDevice[] | SettingsActivity[],
  favouriteData: Farm[] | HubDevice[] | SettingsActivity[],
  latestCollapsedPanelsStates: CollapsedPanelStates,
  tableRef: RefObject<HTMLElement | null>,
) => {
  const updateAvailableFarmsListHeight = useCallback(() => {
    const tableElement = tableRef?.current;

    if (!tableElement) return;

    const distanceToTopEdgeOfBrowserViewport =
      tableElement?.getBoundingClientRect().top || 0;

    const availableSpaceForFarmsListHeight =
      window.innerHeight -
      distanceToTopEdgeOfBrowserViewport -
      PAGE_BOTTOM_PADDING_PX;

    document.documentElement.style.setProperty(
      DYNAMIC_TABLE_HEIGHT_VAR,
      `${availableSpaceForFarmsListHeight}px`,
    );
  }, [tableRef]);

  useEffect(() => {
    updateAvailableFarmsListHeight();
  }, [data, favouriteData, latestCollapsedPanelsStates]);

  useWindowResizeEffect(updateAvailableFarmsListHeight, [
    updateAvailableFarmsListHeight,
  ]);

  const handleTableHeightResize = useCallback(() => {
    updateAvailableFarmsListHeight();
  }, [updateAvailableFarmsListHeight]);

  return handleTableHeightResize;
};

export default useTableHeightResize;
